import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {AuthService} from "../auth.service";

@Component({
  selector: 'app-login-as',
  templateUrl: './login-as.component.html',
  styleUrls: ['./login-as.component.scss']
})
export class LoginAsComponent implements OnInit {

  users = [
    {name: 'Penceo Test', email: 'test@penceo.com', password: 'test'},
    {name: 'Test User', email: 'creever@penceo.com', password: 'test'}
  ];
  constructor(private router: Router, private authenticationService: AuthService) { }

  ngOnInit() {
  }

  loginAs(user) {
    this.authenticationService.fakeLogin(user.email, user.password).subscribe(result => {
      if (result === true) {
        // login successful
        this.router.navigate(['/']);
      } else {
        this.router.navigate(['/not-authorized']);
      }
    }, err => {
      if (err.status === 403) {
        this.router.navigate(['/not-authorized']);
      } else {
        this.router.navigate(['/login']);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/login-as/login-as.component.ts